import { useEffect, useRef } from 'react';

const useDropZone = (onFilesDropped, dragOverClassName = null) => {
  const dropZoneRef = useRef();

  const highlightDropZone = () => {
    if (dropZoneRef && dropZoneRef.current) {
      const dropZone = dropZoneRef.current;
      dropZone.classList.add(dragOverClassName);
    }
  };

  const unhighlightDropZone = () => {
    if (dropZoneRef && dropZoneRef.current) {
      const dropZone = dropZoneRef.current;
      dropZone.classList.remove(dragOverClassName);
    }
  };

  const enableDrag = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (e.target === dropZoneRef.current) {
      if (e.type === 'dragenter') {
        highlightDropZone();
      }
      if (e.type === 'dragleave') {
        unhighlightDropZone();
      }
    }
  };

  const onDrop = (e) => {
    e.preventDefault();
    unhighlightDropZone();
    const { files } = e.dataTransfer;
    onFilesDropped(files);
  };

  useEffect(() => {
    if (dropZoneRef && dropZoneRef.current) {
      const dropZone = dropZoneRef.current;
      const dragEvents = 'dragover dragenter dragleave'.split(' ');

      dropZone.addEventListener('drop', onDrop, false);
      dragEvents.forEach((eventName) => dropZone.addEventListener(eventName, enableDrag, false));
      return () => {
        dropZone.removeEventListener('drop', onDrop);
        dragEvents.forEach((eventName) => dropZone.removeEventListener(eventName, enableDrag));
      };
    }
    return undefined; // a formality, only because of eslint
  });

  return { dropZoneRef };
};

export default useDropZone;
